<div id="achSourceOfFunds">
  <a class="saManageAccountsLink"
    [ngClass]="isAchIn ? 'achInSaManageAccountsLink' : 'achOutSaManageAccountsLink'" (click)="actionCenterRedirect()" *ngIf="enableUseSloaContainer">Add or manage accounts</a>
    <mm-standing-authorization-card-container
      *ngIf="enableUseSloaContainer; else legacyAchSourceOfFunds"
      [label]="standingAuthIdModel.title"
      [authorizationCount]="standingAuthCards.length"
      [cards]="standingAuthCards"
      [disabled]="isStandingAuthIdDisabled"
      (cardSelected)="onStandingAuthCardSelected($event)">
    </mm-standing-authorization-card-container>
    <ng-template #legacyAchSourceOfFunds>
      <mm-card-component [parentForm]="parentForm" [cardModel]="standingAuthIdModel"></mm-card-component>
      <a [ngClass]="isAchIn ? 'achIn' : 'achOut'" (click)="actionCenterRedirect()">Add or manage accounts</a>
    </ng-template>
  </div>